import {
    Box,
    Skeleton,
    TableBody,
    TableCell,
    TableRow,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import {
    TableBodyComponentProps,
    TableBodyLoaderProps
} from "../../types";


const TableBodyLoader = ({
    rowsNum,
    colsNum,
    rowCustomStyles
}: TableBodyLoaderProps) => {
    const theme = useTheme()

    return (
        <>
            {[...Array(rowsNum)].map((_, index) => (
                <TableRow
                    key={index}
                    sx={{
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                        },
                        ...rowCustomStyles
                    }}
                >
                    {[...Array(colsNum)].map((_, index) => (
                        <TableCell key={index}>
                            <Skeleton animation="wave" variant="text" />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    )
};



export default function TableBodyComponent(
    {
        isLoading,
        tableDataCount,
        tableBodyCustomStyles,
        loadingRowsNum,
        loadingColsNum,
        tableBodyLoaderRowCustomStyles,
        tableBody,
    }: TableBodyComponentProps
): JSX.Element {


    return (
        <TableBody
            sx={{
                ...tableBodyCustomStyles
            }}
        >
            {isLoading && (
                <TableBodyLoader
                    rowsNum={loadingRowsNum}
                    colsNum={loadingColsNum}
                    rowCustomStyles={tableBodyLoaderRowCustomStyles}
                />
            )}
            {!isLoading && tableDataCount > 0 && (
                tableBody
            )}
        </TableBody>
    )
}